import { orderManager } from "../../data/managers/OrderManager";
import { StationOrderModel } from "../../data/models/product/ProductModel";
import { useFirestoreListener } from "./useFirestoreListener";

export const useStationOrders = () => {
  const { data: stationOrders, unsubscribe } =
    useFirestoreListener<StationOrderModel>("stations_orders", {
      mapFn: (doc: StationOrderModel) => new StationOrderModel(doc),
      enabled: true,
    });

  const doneStationOrder = async (stationOrderId: string) => {
    try {
      const r = await orderManager.doneStationOrder({
        stationOrderId,
      });
      return r;
    } catch (err) {
      console.error(err);
      return false;
    }
  };

  return {
    stationOrders,
    doneStationOrder,
    unsubscribe,
  };
};
